// http status codes
export const HTTP_STATUS_UNAUTHORIZED: number = 401;

export const COOKIE_AUTHENTICATIONTOKEN: string = "token";
export const COOKIE_REPORTAUTHENTICATIONTOKEN: string = "report_token";

// moment.js format strings
export const MOMENT_FORMAT_DATE: string = "MM/DD/YYYY";
export const MOMENT_FORMAT_TIME: string = "hh:mm A";
export const MOMENT_FORMAT_DATETIME: string = "MM/DD/YYYY hh:mm A";
export const MOMENT_FORMAT_DATETIME_FROM_CONFIG: string = "MM-DD-YYYY HH:mm";
export const MOMENT_FORMAT_TIME_STANDARDIZED = "HH:mm:ss";
export const MOMENT_FORMAT_DATE_STANDARDIZED = "YYYY-MM-DD";

// standard phrases
// there are standard phrases used in dialog boxes and other messages.  Pages should
// uses these constants as much as possible so the entire site has a consistent interface.
export const PHRASE_UNSAVEDCHANGESONCLOSE: string = "There are unsaved changes on this page.  Are you sure you want to " +
    "close this page and lose these unsaved changes?";
export const PHRASE_PAGELOADERROR: string = "An error has occurred while loading this page.  Please try again.";
export const PHRASE_RECORDLOADERROR: string = "An error has occurred while loading the record.  Please try again.";
export const PHRASE_SAVEERROR: string = "An error has occurred saving the record.";
export const PHRASE_INVALIDFIELDSONSAVE: string = "One or more fields have incorrect values.  Please review all warning messages.";
export const PHRASE_RECORDSAVED: string = "Record was saved successfully";
export const PHRASE_PASSWORDCHANGED: string = "Password Updated";
export const PHRASE_RECORDDELETED: string = "Record was deleted successfully";
export const PHRASE_GENERALACTIONFAILURE: string = "An unexpected error has occurred while processing your request.  Please try again.";
export const PHRASE_INVALIDFILETYPESELECTION: string = "The selected file is not permitted. Please select a file with one of these extensions: ";
export const PHRASE_SESSIONEXPIRED: string = "Your session has expired.  Please login and try again.";
export const PHRASE_CHANGEPASSWORDACCOUNTLOCKED: string = "There was a problem updating your password.  Please log in and try again.";
export const PHRASE_EXCELFILEBEINGCREATED: string = "The Excel file is being created, please wait...";
export const PHRASE_UNAUTHORIZEDACCESS: string = "You do not have permissions to perform this action.";
export const PHRASE_FILTER_SHOWACTIVE: string = "Show active";
export const PHRASE_FILTER_SHOWINACTIVE: string = "Show inactive";
export const PHRASE_ITEMSAVED: string = "Item saved";
export const PHRASE_ITEMDELETED: string = "Item deleted";
export const PHRASE_ITEMUNSAVEDCHANGES: string = "There are unsaved changes for this item.  Are you sure you want " +
    "to lose these unsaved changes?";
export const PHRASE_NOTSELECTED: string = "(not selected)";

// labels for 'appointment', 'inspector', etc
export const LABEL_APPOINTMENT: string = "Application";
export const LABEL_APPOINTMENTS: string = "Applications";
export const LABEL_INSPECTOR: string = "Mobile User";
export const LABEL_INSPECTORS: string = "Mobile Users";
export const LABEL_QUESTION: string = "Item";
export const LABEL_QUESTIONS: string = "Items";
export const PHRASE_CANNOTDELETEREADONLYIMAGE: string = `You can not delete Image after ${LABEL_APPOINTMENT} is completed`;

// Values are from the ControlType table
export const QuestionType = {
        TEXTBOX: 1,
        RADIOBUTTONLIST: 2,
        DROPDOWN: 3,
        CHECKBOXLIST: 4,
        TEXTAREA: 5,
        DATE: 6,
        MULTIPLECOMMENTS: 7,
        MULTIPLECOMMENTSPICS: 8,
        TEXTDESCRIPTION: 9,
        SIGNATURE: 10,
        SECTION: 11,
        BUTTON: 12,
        NUMERIC: 13,
        BARCODE: 14,
        DOCUMENTS: 15,
        DATETIME: 16,
        TIME: 17,
        EMAIL: 18,
        PHONE: 19,
        LINKEDDOCUMENTS: 20,
        TARGET: 21,
        ADDRESS: 22,
        PICTURE: 23,
        GEOLOCAITON: 24,
        SLIDER: 25,
        SINGLECHECKBOX: 26,
    };

export const SETTING_KEY_REGISTRATION_CODE: string = "Registration Code";
export const SETTING_KEY_DEFAULT_USER_ROLE: string = "Default User Roles";
export const SETTING_KEY_DEFAULT_TEMPLATEACCESS_ROLE: string = "Default Template Access Roles";

export const SETTING_TYPE_COLOR: string = "color";
export const SETTING_TYPE_IMAGE: string = "image";
export const SETTING_TYPE_DATE: string = "date";
export const SETTING_TYPE_TIME: string = "time";
export const SETTING_TYPE_BOOL: string = "bool";
export const SETTING_KEY_DATEFORMAT = "Date Format";
export const SETTING_KEY_TIMEFORMAT = "Time Format";
export const SETTING_KEY_TEMPLATE_ACCESS_SECURITY = "Template Access Security";
export const SETTING_KEY_MAKE_TASK_READ_ONLY_WHEN_COMPLETED = "Make Task Read-Only When Completed";
export const SETTING_KEY_REPORT_RECIPIENT_EMAIL_ADDRESS = "Report Recipient Email Address";
export const SETTING_KEY_REPORT_RECIPIENT_EMAIL_FIELD_PATH = "Report Recipient Email Field Path";
export const DATE_FORMATS = ["MM/DD/YYYY", "DD/MM/YYYY", "DD-MMM-YYYY"];
export const DEFAULT_TIME_FORMAT: string = "12H";
export const DEFAULT_DATE_FORMAT: string = "MM/DD/YYYY";
export const TIME_PLACEHOLDER: string = "HH:MM";
export const NUMERIC_PLACEHOLDER: string = "0";

interface IKeyValue {
    [key: string]: string;
}
export const MOMENT_DATE_FORMAT_MAP: IKeyValue = {
    "MM/DD/YYYY": "MM/DD/YYYY",
    "DD/MM/YYYY": "DD/MM/YYYY",
    "DD-MMM-YYYY": "DD-MMM-YYYY",
};

export const MOMENT_TIME_FORMAT_MAP: IKeyValue  = {
    "12H" : "h:m A",
    "24H" : "H:m",
};

export const KENDO_DATE_FORMAT_MAP: IKeyValue  = {
    "MM/DD/YYYY": "MM/dd/yyyy",
    "DD/MM/YYYY": "dd/MM/yyyy",
    "DD-MMM-YYYY": "dd-MMM-yyyy",
};

export const KENDO_TIME_FORMAT_MAP: IKeyValue  = {
    "12H" : "hh:mm tt",
    "24H" : "HH:mm",
};

// permissions
export const PERMISSION_PERFORM_APPOINTMENTS: number = 1;
export const PERMISSION_CREATE_APPOINTMENTS: number = 2;
export const PERMISSION_EDIT_APPOINTMENTS: number = 3;
export const PERMISSION_EDIT_USERS: number = 4;
export const PERMISSION_EDIT_FORM_TEMPLATES: number = 5;
export const PERMISSION_EDIT_TEMPLATES: number = 6;
export const PERMISSION_VIEW_APPOINTMENTS: number = 7;
export const PERMISSION_VIEW_TARGETS: number = 8;
export const PERMISSION_EDIT_TARGET_TEMPLATES: number = 9;
export const PERMISSION_EDIT_TEMPLATE_PHRASES: number = 10;
export const PERMISSION_ALL_USERS: number = 11;
export const PERMISSION_EDIT_TARGETS: number = 12;
export const PERMISSION_VIEW_LOCATION_LOGS: number = 13;
export const PERMISSION_VIEW_REPORTS: number = 14;
export const PERMISSION_MANAGE_REPORTS: number = 15;
export const PERMISSION_CUSTOMER_ADMINISTRATION: number = 16;
export const PERMISSION_EDIT_CUSTOMER_CONFIGURATION: number = 17;
export const PERMISSION_EDIT_ALL_CUSTOMER_CONFIGURATION: number = 18;
export const PERMISSION_EDIT_DOCUMENT_LIBRARY: number = 19;
export const PERMISSION_EDIT_TEMPLATE_ACCESS_ROLES: number = 20;
export const PERMISSION_VIEW_MOBILE_USERS: number = 21;
export const PERMISSION_RUN_REPORTS: number = 22;
export const PERMISSION_TASK_DASHBOARD: number = 24;
export const PERMISSION_USE_TASK_ENTRY_PAGE: number = 25;

// From TemplateSettingType table
export const TEMPLATE_SETTING_TYPE_SEND_EMAIL_WHEN_TASK_COMPLETED: number = 1;
export const TEMPLATE_SETTING_TYPE_REPORT_EMAIL_ADDRESS: number = 2;
export const TEMPLATE_SETTING_TYPE_REPORT_EMAIL_FIELD_PATH: number = 3;

export const TEMPLATE_SETTING_GROUP_EMAIL_RECIPIENTS = "EmailRecipients";
export const TEMPLATE_SETTING_GROUP_MOBILE_TASK_LIST = "MobileTaskList";
export const TEMPLATE_MOBILE_SETTING_KEY_FIELD_PATH = "Field Path";

// For templateForm page
export const TEMPLATE_FORM_CHOICES_CUSTOM = "custom";
export const TEMPLATE_FORM_CHOICES_PHRASES = "phrases";
export const SINGLECHECKBOX_ANSWER_FALSE = "false";
export const SINGLECHECKBOX_ANSWER_TRUE = "true";

// Default pages
export const DEFAULT_CONTROLLER = "Dashboard";
export const DEFAULT_CONTROLLER_TASK = "TaskDashboard";

 // Used in samlLogin to check for redirect query parameters
export const QUERYSTRING_PAGE_TO_SHOW = "pagetoshow";
export const QUERYSTRING_HIDE_MENU = "hidemenu";



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/constants.ts